import { UtilF } from '../../../../modules/Util/F/Function/module/UtilF.js';

UtilF.initLazyLoad();
